
















































import { Component, Vue, Prop } from "vue-property-decorator";
import ReadQa from "@/components/qa/read-qa.vue";
@Component({
  components: {
    ReadQa,
  },
})
export default class Name extends Vue {
  @Prop()
  private hideZhishidian: any;
  @Prop()
  private hideImg: any;
  @Prop()
  private ifGoZhishidian: any; // 知识点是否可跳转
  @Prop()
  private data: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  private showReply: any;
  private ifShowWenda: any = false;
  private get curPro() {
    return this.$store.state.curPro;
  }
  private preview(url: any) {
    window.open(url);
  }
  private goZhishidian(item: any) {
    this.$router.push({
      path: "/main/shixun/study-textbook",
      query: {
        data: JSON.stringify({
          chapter_id: item.chapter_id,
          name: item["名称"],
        }),
      },
    });
  }
  private openWenda() {
    this.ifShowWenda = true;
  }
  private cancel() {
    this.ifShowWenda = false;
  }
  private replySure() {
    this.ifShowWenda = false;
    this.$emit("getDetail");
  }
}
